import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './styles/style.css'

const adjustHeightDirective = {
  mounted (el: any) {
    const adjustHeight = () => {
      el.style.height = `${window.innerHeight - 64}px`
    }
    adjustHeight()
    window.addEventListener('resize', adjustHeight)

    el.__cleanup = () => {
      window.removeEventListener('resize', adjustHeight)
    }
  },
  beforeUnmount (el: any) {
    if (el.__cleanup) {
      el.__cleanup()
    }
  }
}

const app = createApp(App)

app.use(store)
  .use(router)
  .directive('adjust-height', adjustHeightDirective)
  .mount('#app')
